module.exports = __webpack_public_path__ + "img/news_1_1.258943b0.jpg";